var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDekstopLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 4.2487C0.9375 3.1729 1.86092 2.30078 3 2.30078H15C16.1391 2.30078 17.0625 3.1729 17.0625 4.2487V11.332C17.0625 12.4078 16.1391 13.2799 15 13.2799H10.6601L11.2226 14.3424H12.75C13.0607 14.3424 13.3125 14.5803 13.3125 14.8737C13.3125 15.1671 13.0607 15.4049 12.75 15.4049H5.25C4.93934 15.4049 4.6875 15.1671 4.6875 14.8737C4.6875 14.5803 4.93934 14.3424 5.25 14.3424H6.77735L7.33985 13.2799H3C1.86092 13.2799 0.9375 12.4078 0.9375 11.332V4.2487ZM15 12.2174H3C2.48223 12.2174 2.0625 11.8211 2.0625 11.332V4.2487C2.0625 3.75969 2.48223 3.36328 3 3.36328H15C15.5178 3.36328 15.9375 3.75969 15.9375 4.2487V11.332C15.9375 11.8211 15.5178 12.2174 15 12.2174Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDekstopLogin);
export default __webpack_public_path__ + "static/media/dekstop-login.dae7c4cd9df98910b5f484799bd440a9.svg";
export { ForwardRef as ReactComponent };